import OkTableConfigType from '@/@bya3/components/tables/ok-table/OkTableConfigType'
import { API_URL } from '@/constants/config'
import store from '@/store'

const InstaAccountsTableConfig: OkTableConfigType = {
  mode: 'remote',
  url: `${API_URL}/admin/instagram/accounts`,
  rowsPath: 'accounts',
  rowClickable: true,
  attachPageId: false,
  actionFirst: true,
  actions: [
    {
      label: 'page.renew',
      eventName: 'renew',
      icon: 'RefreshCcwIcon',
      disabled: (page: any) => page.package?.trial ?? false,
    },
    {
      label: 'forms.edit',
      eventName: 'edit',
      icon: 'EditIcon',
    },
    {
      label: 'forms.delete',
      eventName: 'delete',
      icon: 'Trash2Icon',
    },
    {
      label: 'page.block',
      eventName: 'block',
      icon: 'MinusCircleIcon',
    },
    {
      label: 'page.check-permissions',
      eventName: 'check-permissions',
      icon: 'DiscIcon',
    },
    {
      label: 'page.add-permissions',
      eventName: 'add-permissions',
      icon: 'PlusIcon',
    },
    {
      label: 'page.add-menu',
      eventName: 'add-menu',
      icon: 'MenuIcon',
    },
    {
      label: 'page.remove-menu',
      eventName: 'remove-menu',
      icon: 'MinusSquareIcon',
    },
  ],
  columns: [
    {
      label: 'fields.id',
      field: 'id',
    },
    {
      label: 'page.name',
      field: 'name',
    },
    {
      label: 'page.is-direct',
      field: 'is_direct',
    },
    {
      label: 'page.expired',
      field: 'expired',
    },
    {
      label: 'page.package-name',
      field: 'package-name',
    },
    {
      label: 'page.package-price',
      field: 'package-price',
    },
    {
      label: 'Poster AI enabled',
      field: 'ai_enabled',
    },
    {
      label: 'reply.form.ai_used',
      field: 'ai_used',
    },
    {
      label: 'Poster AI Limit',
      field: 'ai_limit',
    },
    {
      label: 'AI Reply Limit',
      field: 'ai_reply_limit',
    },
    {
      label: 'Reset period',
      field: 'reset_period',
    },
    {
      label: 'invoice.invoices',
      field: 'invoices_count',
    },
    {
      label: 'invoice.unpaid-invoices',
      field: 'unpaid_invoices_count',
    },
  ],
  paginationOptions: {
    enabled: true,
  },
  sortOptions: {
    enabled: false,
  },

  filters: [
    {
      label: 'fields.general-search',
      query: 'search',
      colLength: 3,
    },
    {
      label: 'page.is-direct',
      query: 'is_direct',
      colLength: 3,
      type: 'select',
      multiple: false,
      options: [{ text: 'general.yes', value: 1 }, { text: 'general.no', value: 0 }],
      optionsLabel: { keyLabel: 'text', valueLabel: 'value', translate: true },
    },
    {
      label: 'invoice.paid',
      query: 'paid',
      colLength: 3,
      type: 'select',
      multiple: false,
      options: [{ text: 'general.yes', value: 1 }, { text: 'general.no', value: 0 }],
      optionsLabel: { keyLabel: 'text', valueLabel: 'value', translate: true },
    },
    {
      label: 'page.package',
      query: 'package',
      colLength: 3,
      type: 'select',
      multiple: false,
      options: () => store.getters['subscription/packages'].filter((p: any) => p.media_type === 'ig'),
      optionsLabel: { keyLabel: 'name', valueLabel: 'id', translate: false },
    },
    {
      label: 'page.referral',
      query: 'referral',
      colLength: 3,
      type: 'select',
      multiple: false,
      options: () => store.getters['auth/referrals'],
      optionsLabel: { keyLabel: 'name', valueLabel: 'id', translate: false },
    },
    {
      label: 'page.expire-date',
      query: 'expires',
      colLength: 3,
      type: 'range',
      range_type: 'date',
    },
    {
      label: 'Poster AI enabled',
      query: 'ai_enabled',
      colLength: 3,
      type: 'select',
      multiple: false,
      options: () => [{ name: 'general.yes', id: 1 }, { name: 'general.no', id: 0 }],
      optionsLabel: { keyLabel: 'name', valueLabel: 'id', translate: true },
    },
    {
      label: 'Reset period',
      query: 'reset_period',
      colLength: 3,
      type: 'select',
      multiple: false,
      options: () => [{ name: 'Daily', id: 'daily' }, { name: 'Monthly', id: 'monthly' }],
      optionsLabel: { keyLabel: 'name', valueLabel: 'id', translate: false },
    },
  ],
}

export default InstaAccountsTableConfig
